import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { BasicFlex, ScrollableContainer } from "../../../../utils/Common";

import ConfirmationNumberRoundedIcon from '@mui/icons-material/ConfirmationNumberRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

const KanbanContainer = styled.div`
    overflow-x: auto;

  @media ${props => props.theme.breaks.down('md')} {
    overflow-x: auto;
    width: 100%;
  }
`

const KanbanBoard = styled.div`
  display: flex;
  gap: 1.5rem;
`
const KanbanTrack = styled.div`
  min-width: 30rem;
  height: calc(100vh - 25rem);
`

const KanbanTrackHeader = styled(BasicFlex)`
 /* padding: 1rem; */
 margin-bottom: 1rem;
 background-color: ${props => props.$color ? props.$color : props.theme.colors.primaryFaint};
 border-radius: .8rem;
 padding: .6rem 1rem;
`

const KanbanTrackHeaderTitle = styled.div`
  /* font-size: 1.2rem; */
  font-weight: 600;
  /* color: ${props => props.theme.colors.lightText}; */
`

const KanbanTrackHeaderInfo = styled(BasicFlex)`
  gap: 1.6rem;
  min-width: fit-content;
  padding-left: .3rem;
`

const KanbanTrackHeaderActions = styled(BasicFlex)`
  gap: .8rem;
  justify-content: flex-end;
`

const KanbanDot = styled.div`
  width: .8rem;
  height: .8rem;
  border-radius: 50%;
  background-color: ${props => props.$color ? props.$color : props.theme.colors.primary};
`

const KanbanScrollable = styled(ScrollableContainer)`
  border-radius: 8px;
  padding: 1rem .5rem;
  background-color: ${props => props.theme.colors.darkBg};
  min-height: calc(100% - 5rem);
  max-height: calc(100% - 5rem);
  width: 30rem;

  ${props => props.$static ? css/* closed */`
    border-width: 2px;
    border-color: ${props.theme.colors.veryLightText};
  ` : ""}
`

const NoTicketsStyles = styled(BasicFlex)`
  width: 100%;
  /* height: 100%; */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.mildText};
  font-weight: 500;
  margin-top: 2rem;
`

const NoTickets = () => {
  return (
    <NoTicketsStyles gap=".5rem">
      <ReceiptLongRoundedIcon fontSize="large" color="icon" />
      <div>No tickets</div>
    </NoTicketsStyles>
  )
}

export {
  KanbanContainer,
  KanbanBoard,
  KanbanTrack,
  KanbanTrackHeader,
  KanbanTrackHeaderTitle,
  KanbanTrackHeaderInfo,
  KanbanTrackHeaderActions,
  KanbanDot,
  KanbanScrollable,

  NoTickets
}